import { PropertyType } from 'esa-ui-library/lib/types';
import { OptionType, TableHeaderType, isValidFloat } from '../../../common';
import { reportConstants } from '../../constants/reports';
import { isEmpty, isInteger, set } from 'lodash';

export const filterFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter(
			(f) =>
				f.label !== reportConstants.REPORT_PGDA_831 &&
				f.label !== reportConstants.REPORT_AAMS_GAME_ID &&
				f.label !== reportConstants.REPORT_AAMS_GAME_TYPE
		);
	}

	return result;
};

export const getFiltersUrl = (filters: PropertyType[]): string => {
	const urlFragments = filters.map((f) => `${f.name}=${f.value}`);
	return `?${urlFragments.join('&')}`;
};

export const filterSearchOptionsByEnv = (fields: OptionType[]): OptionType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.value !== 'aams_game_ids');
	}

	return result;
};

export const getErrorMessage = (field: string): string => `${field} is required`;

export const validateForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.game_name) {
		errors.game_name = getErrorMessage('Game name');
	}
	// if (!form.game_provider_id && form.game_provider_id.length === 0) {
	// 	errors.game_provider_id = getErrorMessage('Game provider');
	// }
	if (!form.provider_game_id_desktop) {
		errors.provider_game_id_desktop = getErrorMessage('ID');
	}
	if (!form.provider_game_id_mobile) {
		errors.provider_game_id_mobile = getErrorMessage('ID');
	}
	// if (form.aams_type_id.length === 0) {
	// 	errors.aams_type_id = getErrorMessage('AAMS Type');
	// }
	if (form.rtp) {
		if (!isValidFloat(form.rtp)) {
			errors.rtp = 'RTP must be a decimal number';
		} else if (form.rtp.toString().length > 8) {
			errors.rtp = 'RTP must not exceed 8 digits in total';
		}
	}
	if (form.volatility !== null && form.volatility !== undefined && form.volatility !== '') {
		if (!isInteger(+form.volatility)) {
			errors.volatility = 'Volatility must be a whole number';
		} else if (form.volatility.toString().length > 8) {
			errors.volatility = 'Volatility must not exceed 8 digits';
		}
	}
	if (form.wagering_weight !== null && form.wagering_weight !== undefined && form.wagering_weight !== '') {
		if (!isInteger(+form.wagering_weight)) {
			errors.wagering_weight = 'Wagering weight must be a whole number';
		} else if (form.wagering_weight.toString().length > 8) {
			errors.wagering_weight = 'Wagering weight must not exceed 8 digits';
		}
	}
	if (form.custom_fields?.length) {
		form.custom_fields.map((field: PropertyType) => {
			if (!field.name) {
				set(errors, `${field.id}.name`, getErrorMessage('Name'));
			}
			if (!field.value) {
				set(errors, `${field.id}.value`, getErrorMessage('Value'));
			}
		});
	}

	return !isEmpty(errors) ? errors : null;
};

export const validateImportForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.file) {
		errors.file = getErrorMessage('File need to be attached');
	}

	return !isEmpty(errors) ? errors : null;
};

export const validateBulkAssignPartnersForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.file) {
		errors.file = getErrorMessage('File need to be attached');
	}

	return !isEmpty(errors) ? errors : null;
};

export const validateEnableGamesForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.file) {
		errors.file = getErrorMessage('File need to be attached');
	}

	return !isEmpty(errors) ? errors : null;
};
